// Texilmesa L57 Kingspool Winder
import React from "react";
import { CommonRows, GrafRow, InputRangeRow, MinMaxRow, RunTimeRow } from "./index";

export default function MachineTexKingSpool() {
   return (
      <>
         <InputRangeRow
            titleProp={"Clock Setting"}
            descriptionProp={"m"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={999999}
            propertyNameProp={"clockSet"}
            errorDialogueProp={"0-999,999 only"}
            floatProp={false}
         />
         <GrafRow minProp={0.0} maxProp={19.9} errorProp={"0.0-19.9 only"} />
         <RunTimeRow />
         <MinMaxRow
            titleProp={"Tension Disk"}
            descriptionProp="g"
            minProp1={0}
            maxProp1={300}
            floatProp1={false}
            errorProp1={"0-300 only"}
            minProp2={0}
            maxProp2={300}
            floatProp2={false}
            errorProp2={"0-300 only"}
            valueProp1={"tensionMin"}
            valueProp2={"tensionMax"}
         />
         <CommonRows />
      </>
   );
}
